import React, { useState } from "react";
import CheckboxIcon from "../svg/checkboxIcon"; // Icon for unchecked checkbox
import CheckboxIconChecked from "../svg/checkboxIcon-checked"; // Icon for checked checkbox
import Link from "next/link";

interface CheckboxProps {
    label?: string;
    required?: boolean;
    checked: boolean;
    onChange: (checked: boolean) => void;
    link?: string;
    linktext?: string;
    customClass?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
    label,
    checked,
    onChange,
    link,
    linktext,
    customClass
}) => {
    const handleChange = () => {
        onChange(!checked);
    };

    return (
        <div className="flex flex-col">
            <input
                type="checkbox"
                checked={checked}
                onChange={handleChange}
                className="hidden"
            />
            <div className="flex items-start">
                <div onClick={handleChange} className={`w-[24px] h-[24px] flex items-center justify-center cursor-pointer mt-[2px]`}>
                    {checked ? (
                        <CheckboxIconChecked /> 
                    ) : (
                        <CheckboxIcon /> 
                    )}
                </div>
                {label && <span className={`ml-[4px] text-black-50 text-base font-medium leading-[125%]  max-[576px]:text-[12px] max-[576px]:leading-[100%] ${customClass}`}>
                    {label} {link && linktext ? (
                        <Link
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => {
                        e.stopPropagation(); 
                        e.preventDefault();  
                        window.open(link, "_blank"); 
                        }}
                        className="font-bold text-violet-500 underline text-base max-[576px]:text-[12px]"
                    >
            {linktext}
          </Link>
                    ) : ''}</span>
                }
            </div>

        </div>
    );
};

export default Checkbox;
